export enum ActionType {
    UPDATE_MAIN_UI = 'UPDATE_MAIN_UI',
    MAIN_UI_DASHBOARD = 'MAIN_UI_DASHBOARD',
    MAIN_UI_ORDER_HISTORY = 'MAIN_UI_NUMBER_HISTORY',
    MAIN_UI_PAYMENT_HISTORY = 'MAIN_UI_PAYMENT_HISTORY',

    URL_CHANGED = 'URL_CHANGED'
}

export interface ActionMain {
    type: ActionType.UPDATE_MAIN_UI
}
type Action = ActionMain

export default Action